<div class="item-selector-content">
  <div class="button-section">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ labelKey | translate }}</mat-label>
      <mat-select [disabled]="isDisabled() || !noOptions" [(ngModel)]="selectedItem" (selectionChange)="addItem($event)">
        @for (option of (options | selector:items:updated); track options) {
          <mat-option [value]="option.value">{{ option.text }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <mat-list role="list" class="full-width">
    @for (item of items; track item){
      <mat-list-item role="listitem">
        {{ item.text }}
        <button mat-icon-button [disabled]="isDisabled() || (disableDeleteIfSingle && items.length === 1)" (click)="removeItem(item)">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-list-item>
    }
  </mat-list>
</div>